import React, { useState, useEffect } from 'react';
import { LinearProgress } from '@mui/material';

import { CatalogService } from 'api/catalog/services';
import { DEFAULT_BRAND_SEARCH } from 'constants/brands';
import { HostSystem } from 'constants/HostSystem';

interface IProps {
  children: React.ReactNode;
}

export const AuthenticationProvider = ({ children }: IProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    CatalogService.getBrands({
      brandRegex: DEFAULT_BRAND_SEARCH,
      hostSystems: [HostSystem.UCS],
    })
      .then(() => {
        setIsError(false);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading || isError) {
    return <LinearProgress sx={{ width: '100%' }} />;
  } else {
    return <>{children}</>;
  }
};

export default AuthenticationProvider;
